<template>
  <div id='gold_admin'>
    <CategorySelection id='cat_selection' class='z_4' />
    <ItemSelection id='item_selection' class='z_3' />
    <div id='no_products_shown' v-if='$route.name === "gold-admin"'>

      <h2>
        <NoProducts/>
        Select an item to see its available products.<br> Narrow items by selecting a category.<br> </h2>
      <div class='stats'>

      </div>
    </div>
    <transition name='fade'>
      <div id='loadingWrap' v-if='loading.products'>
        <SpinningLoader />
      </div>
    </transition>

    <router-view />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SpinningLoader from '$shared/loaders/SpinningLoader.vue'
import NoProducts from '$svgs/NoProducts.vue'
import CategorySelection from '@/components/gold-admin/CategorySelection.vue'
import ItemSelection from '@/components/gold-admin/ItemSelection.vue'
export default {
  computed: {
    ...mapState('system', ['loading', 'products'])
  },
  components: {
    CategorySelection,
    ItemSelection,
    SpinningLoader,
    NoProducts
  }
}
</script>
<style lang='scss'>
#cat_selection{
  left:0;
}
#item_selection{
  left:18rem;
}
#no_products_shown{
    top: 0;
    left: 3rem;
    padding: 3rem;
    margin-bottom: 3rem;
    border-bottom: 1px solid #d0d0e2;

  @include full_wh;
  width: calc(100% - 31rem);
  left: 31rem;
  h2{
    color:#b6b5c5;
    text-align: center;
    position: relative;
    top: 40%;
    transform: translateY(-50%);
    .no-products{
      display: block;
      position: relative;
      width: 11rem;
      margin: 0 auto;
      margin-bottom: 3rem;
      opacity: 0.75;
    }
  }
}
#loadingWrap{
  @include full_wh;
  width: calc(100% - 31rem);
  left:31rem;
  background: #eeeef5;
  z-index: 2;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/gold-admin/GoldAdmin.vue